import * as ActionTypes from '../actions'



const patients = (state = [], action) => {
	switch (action.type) {
		case ActionTypes.LOAD_PATIENTS_SUCCESS:
			return action.response
		case ActionTypes.LOGOUT:
			return []
		default:
			return state
	}
}

export default patients


// WEBPACK FOOTER //
// ./src/reducers/patients.js